import { lazy } from 'react';

const componentFromLazy = (
  component:
    | Promise<{ default: React.ComponentType<unknown> }>
    | (() => Promise<{ default: React.ComponentType<unknown> }>)
): React.LazyExoticComponent<React.ComponentType<unknown>> => {
  const Component =
    typeof component === 'function' ? lazy(component) : lazy(() => component);
  return Component;
};

export default componentFromLazy;
